import { isNil, isNumber, isString } from "lodash";

import { isTimespanNegative } from "../modules/definition/calendar/dateFunctions/timespanFunctions";

const noEmpty = value => !isNil(value) && (isNumber(value) || (isString(value) && value.length > 0));

const itemDuration = duration => {
  return !duration || !isTimespanNegative(duration);
};

const positiveNumber = value => isNumber(value) && value > 0;

const zeroOrPositiveNumber = value => isNumber(value) && value >= 0;

export default { noEmpty, itemDuration, positiveNumber, zeroOrPositiveNumber };
